import React from "react";
import Privacy from "@components/Privacy/index.js";
import Terms from "@components/Terms/index.js";
import Checkbox from "@components/Ui/Checkbox/index.js";


const TermsCheckbox = ({ isBypassActive, termsAccepted, onToggle, openModalWithContent }) => (
    <div className="terms-drawer__wrapper">
        <Checkbox
            id="terms-drawer-checkbox"
            buttonAlignment="left"
            checked={termsAccepted}
            onChange={onToggle}
        >
            {isBypassActive ? (
                <>
                    I agree to the{" "}
                    <a href="#terms" className="inline-link" onClick={(e) => { e.preventDefault(); openModalWithContent(<Terms />, "medium"); }}>
                        terms and conditions
                    </a>{" "}
                    of use and the{" "}
                    <a href="#privacy-collection-notice" className="inline-link" onClick={(e) => { e.preventDefault(); openModalWithContent(<Privacy />, "medium"); }}>
                        privacy collection notice
                    </a>.
                </>
            ) : (
                <>
                    I accept the{" "}
                    <a href="#terms" className="inline-link" onClick={(e) => { e.preventDefault(); openModalWithContent(<Terms />, "medium"); }}>
                        Terms &amp; Conditions
                    </a>{" "}
                    of purchase
                </>
            )}
        </Checkbox>
    </div>
);

export default TermsCheckbox;
